// extracted by mini-css-extract-plugin
export default {"container":"styles_container__bz49w","input":"styles_input__rdD4E","icon":"styles_icon__WbMGj","loader":"styles_loader__A+X7A","iconSearch":"styles_iconSearch__0lKVi"};